module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/care-form-task-82678c1f779233bba670e3f60e31431a.svg";